import { render } from "./maquinaExpendedora.vue?vue&type=template&id=4ac79441&scoped=true"
import script from "./maquinaExpendedora.vue?vue&type=script&lang=js"
export * from "./maquinaExpendedora.vue?vue&type=script&lang=js"

import "./maquinaExpendedora.vue?vue&type=style&index=0&id=4ac79441&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac79441"]])

export default __exports__